import React, { useState, useEffect } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
import axios from "axios";
import Visualizza_singolo_progetto from "../components/Progetto_x9_visualizza_singolo_progetto.jsx";

// toolmemo  boh
function cerca_la_pagina_successiva  (indice, lista_aux)  {
    
    let indice_trovato = -1
    lista_aux.map((item, index) => {
        console.log ('v ' + item.code)
        if (index > indice && item.code != '' && indice_trovato == -1) {indice_trovato = item.page; }
    })
    return indice_trovato
};

const Codifica_del_QR_nella_pagina = (props) => {
    const [progetto, SET_progetto] = useState({});
    const [doc_tipo, SET_doc_tipo] = useState({});
      
    useEffect(() => {
        let str = props.qr_passato.code;
        let attore 
        let id 
        
        attore = str.split('doc=').pop().split('&')[0];
        SET_doc_tipo(attore) 
        id = str.split('id=').pop();

        axios.get('/progetti/trova_progetto/' + id)
        .then((res) => {
            console.log('/progetti/trova_progetto/')
//            console.log(res.data)
            SET_progetto(res.data)
            console.log('X ' + props.index)

            var lista_aux = props.lista_qrData
            lista_aux[props.index].descrizione = res.data.id_alunno.cognome + '_' + res.data.id_alunno.nome + '_vs_' + res.data.id_ditta.ragione_sociale
            lista_aux[props.index].pagina_iniziale = lista_aux[props.index].page 
            lista_aux[props.index].attore = attore 
            lista_aux[props.index].id = id 

            let pagina_successiva = cerca_la_pagina_successiva (props.index, lista_aux)
            lista_aux[props.index].pagina_finale = pagina_successiva 

            if (attore === 'P1') {lista_aux[props.index].tipologia_documento = 'Foglio_firme_giornaliero' } 
            if (attore === 'P2') {lista_aux[props.index].tipologia_documento = 'Valutazione_finale' } 

            props.SET_QR_Data([... lista_aux])
           
        }).catch((error) => {
            console.log(error)
        });

    }, [props.qr_passato.code]);




    const parsedJson = () => {
        return <>

         {doc_tipo === 'P1' && <h4> Pagina {props.qr_passato.page} - foglio_firme </h4>}
         {doc_tipo === 'P2' && <h4> Pagina {props.qr_passato.page} - Valutazione </h4>}
     
         {/* doc_tipo == 'ore' && <> {progetto._id} </> */}
         {progetto._id !== undefined && <Visualizza_singolo_progetto progetto={progetto} />}
                  
        </>
    };

    return (
    <div>{parsedJson()}  </div>
    )
}
export default Codifica_del_QR_nella_pagina;